import React from "react";
import { Card, Nav, Pagination, Table } from "react-bootstrap";
import { showPageNumbers } from "../../../utils/table";
import styles from "./TrancheHistoryModal.module.css";
import Select from "react-select";
import clsx from "clsx";
import { TableSkeleton } from "../../../skeleton/TableSkeleton";

const columns = [
  {
    id: "user",
    label: "User",
  },
  {
    id: "statusDate",
    label: "Status Date",
  },
  {
    id: "status",
    label: "Status",
  },
  {
    id: "changeType",
    label: "Change Type",
  },
  {
    id: "dealName",
    label: "Deal Name",
  },
  {
    id: "assetId",
    label: "Asset Id",
  },
];

const paginationOptions = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
];

export const TrancheHistoryTable = ({
  isLoading,
  rows,
  currentPage,
  setCurrentPage,
  totalDocs,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const totalPages = Math.ceil(totalDocs / itemsPerPage);
  const showPaginationNumbers = totalPages > 10;

  const updateItemPerPage = (selected) => {
    if (selected) {
      setItemsPerPage(selected.value);
      setCurrentPage(1);
    }
  };

  return (
    <>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Card
          border="light"
          className="table-wrapper table-responsive shadow-sm"
        >
          <Card.Body className="pt-0">
            <Table hover className="user-table align-items-center table-striped">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th key={col.id}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!rows.length ? (
                  <tr>
                    <td className="bg-grey" colSpan={100}>
                      No Data Found.
                    </td>
                  </tr>
                ) : (
                  rows?.map((row) => (
                    <tr
                      key={row._id}
                      // className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      {columns.map((col) => {
                        console.log("col", col, row[col.id]);

                        return <td key={col.id}>{row[col.id] ?? "-"}</td>;
                      })}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Card.Body>

          <Card.Footer
            className={clsx(
              "px-3 border-0 d-lg-flex justify-content-between",
              styles.stickyFooter
            )}
          >
            <Nav>
              <Pagination className="mb-2 mb-lg-0">
                <Pagination.Prev
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </Pagination.Prev>
                {showPaginationNumbers && (
                  <>
                    {currentPage > 4 && (
                      <>
                        <Pagination.Item onClick={() => setCurrentPage(1)}>
                          1
                        </Pagination.Item>
                        <Pagination.Ellipsis disabled />
                      </>
                    )}
                    {[...Array(totalPages)].map((_, page) => {
                      if (showPageNumbers(page, currentPage, totalPages)) {
                        return (
                          <Pagination.Item
                            key={page + 1}
                            active={page + 1 === currentPage}
                            onClick={() => setCurrentPage(page + 1)}
                          >
                            {page + 1}
                          </Pagination.Item>
                        );
                      }
                      return null;
                    })}
                    {currentPage < totalPages - 3 && (
                      <>
                        <Pagination.Ellipsis disabled />
                        <Pagination.Item
                          onClick={() => setCurrentPage(totalPages)}
                        >
                          {totalPages}
                        </Pagination.Item>
                      </>
                    )}
                  </>
                )}
                <Pagination.Next
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, Math.ceil(totalDocs / itemsPerPage))
                    )
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </Pagination.Next>
              </Pagination>
            </Nav>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              Items Per Page
              <Select
                options={paginationOptions}
                defaultValue={paginationOptions.find(
                  (opt) => opt.value === itemsPerPage
                )}
                onChange={(selected) => updateItemPerPage(selected)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "32px",
                    height: "32px",
                    fontSize: "14px",
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    height: "32px",
                    padding: "0 6px",
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    height: "32px",
                  }),
                  option: (provided) => ({
                    ...provided,
                    fontSize: "14px",
                    padding: "6px 12px",
                    minHeight: "28px",
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    paddingTop: 0,
                    paddingBottom: 0,
                  }),
                }}
                menuPlacement="top"
              />
            </div>
          </Card.Footer>
        </Card>
      )}
    </>
  );
};
